import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/SlaPoliciesTable.styles'

/**
 * Built on the row's own grid, like the other two lists' skeletons. This list
 * had none — before or after the conversion — which made it the one place a
 * loading policy list showed a bare header over nothing.
 */
const SlaPolicyRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      {Array(5)
        .fill('')
        .map((_, index) => (
          <div key={`sla-policy-skeleton-cell-${index.toString()}`}>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        ))}
      <div />
    </div>
  )
}

export default SlaPolicyRowSkeleton
